/** Primary app navigation — shared by bottom bar (mobile) and header (desktop). */
export const NAV_LINKS = [
  { name: 'Menú', url: '/menu/products', icon: 'food' },
  { name: 'Ganancias', url: '/earnings', icon: 'chart bar outline' },
  { name: 'Cuentas', url: '/bills', icon: 'file alternate outline' },
];
